import React from "react";

import "./_Default.css";

function Footer() {
    return (
        <div className="Lower">
            <a href="https://chibiininja.itch.io/">itch.io</a>
            <a href="https://bsky.app/profile/chibiininja.itch.io">Bluesky</a>
            <a href="https://instagram.com/chibiininja/">Instagram</a>
            <a href="https://www.linkedin.com/in/darren-inouye/">LinkedIn</a>
            <a href="https://github.com/chibiininja">GitHub</a>
        </div>
    );
};

export default Footer;